import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { actions as appActions } from '../actions/app';
import { actions as savedItemsActions } from '../actions/savedItems';
import SidebarState from '../constants/sidebarState';
import Footer from '../components/Footer';
import FolderTree from '../components/SavedItems/FolderTree/FolderTree';
import SavedItemsList from '../components/SavedItems/SavedItemsList';
import { Container, StickyHeader, MainContent } from '../styled-components/Layout';
import ControlBar from '../components/SavedItems/ControlBar';
import Pagination from '../components/Pagination';
import App from '../constants/app';

const SavedItemsContent = styled(Container)`
  flex-direction: row;
  height: 100%;
  width: 100%;
`;

const SavedItemsContainer = styled(Container)`
  width: 100%;
`;

const SavedItemsColumn = styled.div`
  display: flex;
  flex-flow: row wrap;
  height: 100%;
  width: 100%;
  flex-basis: ${props => props.flexBasis || 'auto'};
`;

const PaginationContainer = styled.div`
  position: fixed;
  bottom: ${props => props.bottom || App.FOOTER_HEIGHT};
  right: 1.2rem;
  flex-direction: column;
`;

class SavedItemsLayout extends Component {
  constructor() {
    super();

    this.state = {
      selectedItemId: null
    };
  }
  componentDidMount() {
    this.props.changeSidebarState(SidebarState.NONE);
    this.props.getSavedItemFolders();
    if (this.props.selectedFolder >= 0) {
      this.props.getSavedItems();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.configLoaded && nextProps.configLoaded) {
      this.props.changeFooterHeight('0rem');
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    const userLoggedIn = nextProps.authenticated;
    const assetsNeedUpdate = nextProps.needUpdate;
    const assetsLoading = nextProps.assetsLoading;

    if (
      (!this.props.initialized && nextProps.initialized && userLoggedIn) ||
      (!this.props.authenticated && userLoggedIn)
    ) {
      this.props.getSavedItemFolders();
    }

    if (assetsNeedUpdate && userLoggedIn && nextProps.initialized && !assetsLoading) {
      this.props.getSavedItems();
    }
  }

  onItemClick = id => {
    this.setState({ selectedItemId: id });
  };

  render() {
    const { footerHeight, totalPages, pageNumber, changePage, loadSavedItem } = this.props;

    return (
      <Container>
        <SavedItemsContent>
          <SavedItemsColumn flexBasis="15rem">
            <FolderTree />
          </SavedItemsColumn>
          <SavedItemsColumn>
            <SavedItemsContainer>
              <StickyHeader>
                <ControlBar selectedItemId={this.state.selectedItemId} />
              </StickyHeader>
              <MainContent>
                <SavedItemsList
                  selectedItemId={this.state.selectedItemId}
                  onItemDoubleClick={res => loadSavedItem(res.id)}
                  onItemClick={res => this.onItemClick(res.id)}
                />
              </MainContent>
            </SavedItemsContainer>
          </SavedItemsColumn>
          <PaginationContainer bottom={footerHeight}>
            <Pagination
              totalPages={totalPages}
              currentPage={pageNumber}
              buffer={2}
              onChange={changePage}
            />
          </PaginationContainer>
        </SavedItemsContent>
        <Footer />
      </Container>
    );
  }
}

SavedItemsLayout.defaultProps = {
  selectedFolder: null
};

SavedItemsLayout.propTypes = {
  changeSidebarState: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  authenticated: PropTypes.bool.isRequired,
  footerHeight: PropTypes.string.isRequired,
  changeFooterHeight: PropTypes.func.isRequired,
  configLoaded: PropTypes.bool.isRequired,
  initialized: PropTypes.bool.isRequired,
  savedItemsLoading: PropTypes.bool.isRequired,
  getSavedItems: PropTypes.func.isRequired,
  getSavedItemFolders: PropTypes.func.isRequired,
  loadSavedItem: PropTypes.func.isRequired,
  selectedFolder: PropTypes.number
};

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
  userId: state.auth.user.userId,
  needUpdate: state.savedItems.needUpdate,
  pageNumber: state.savedItems.pageNumber,
  totalPages: state.savedItems.totalPages,
  shortcuts: state.keyShortcuts.shortcuts,
  footerHeight: state.app.footerHeight,
  configLoaded: state.app.configLoaded,
  initialized: state.app.initialized,
  savedItemsLoading: state.savedItems.savedItemsLoading,
  selectedFolder: state.savedItems.selectedFolder
});

const mapActionCreators = {
  reload: savedItemsActions.reload,
  changeSidebarState: appActions.changeSidebarState,
  changePage: savedItemsActions.changePage,
  changeFooterHeight: appActions.changeFooterHeight,
  getSavedItems: savedItemsActions.getSavedItems,
  getSavedItemFolders: savedItemsActions.getSavedItemFolders,
  loadSavedItem: savedItemsActions.loadSavedItem
};

export default connect(
  mapStateToProps,
  mapActionCreators
)(SavedItemsLayout);



// WEBPACK FOOTER //
// ./app/layouts/SavedItemsLayout.js